import * as React from "react";
import styled from "@emotion/styled";
import inclusiverseTitle from "assets/images/step-into-the-inclusiverse_sparkly.svg";
import {
  Container,
  IconReactionThoughtProvoking,
  IconHandsYay,
  IconStar,
  Link,
  Text,
} from "atoms";
import { AuthStatus } from "../types";

function HomeInclusiverse({ authStatus, ...props }: AuthStatus) {
  return (
    <HubSection>
      <Container width="sm">
        <InclusiverseGrid {...props}>
          <InclusiverseTitle>
            <img src={inclusiverseTitle} alt="Step into the inclusiverse" />
          </InclusiverseTitle>

          <InclusiverseTasks>
            <ul>
              <li>
                <IconHandsYay />
                <Text size="xs" bold>
                  Discover diverse NFT creators&nbsp;&&nbsp;collections
                </Text>
              </li>
              <li>
                <IconReactionThoughtProvoking />
                <Text size="xs" bold>
                  Share your thoughts on creators&nbsp;&&nbsp;collections
                </Text>
              </li>
              <li>
                <IconStar />
                <Text size="xs" bold>
                  Earn rewards and win&nbsp;exclusive&nbsp;prizes
                </Text>
              </li>
            </ul>
          </InclusiverseTasks>

          <InclusiverseAbout>
            <Text size="xs" bold>
              HUG is committed to embracing Web3 creators and building a more
              diverse and inclusive&nbsp;ecosystem.
            </Text>
            <Text size="xs">
              We welcome newcomers and experts alike, while giving plenty of
              hugs along&nbsp;the&nbsp;way!
            </Text>
          </InclusiverseAbout>

          <InclusiverseCTA>
            {authStatus === "user" ? (
              <>
                <Text bold>Buy a HUG Pass to unlock&nbsp;reviews</Text>
                <Link
                  variant="gradient"
                  size="md"
                  href="https://opensea.io/collection/hugpass"
                >
                  Buy a HUG Pass
                </Link>
              </>
            ) : (
              <>
                <Text bold>
                  Connect your wallet to gain access to all collection and
                  creator&nbsp;profiles
                </Text>
                <Link variant="gradient" size="md" to="/sign-in">
                  Join The HUG
                </Link>
              </>
            )}
          </InclusiverseCTA>
        </InclusiverseGrid>
      </Container>
    </HubSection>
  );
}
const InclusiverseGrid = styled.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem",
  [theme.breakpoints.desktop]: {
    gap: "2rem",
  },
}));
const InclusiverseTitle = styled.div({
  flex: "0 0 100%",
  img: {
    display: "block",
    margin: "0 auto",
    maxWidth: 560,
    transform: "translateX(3%)",
    width: "100%",
  },
});
const Box = styled.div(({ theme }) => ({
  borderRadius: 20,
  padding: "2rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.desktop]: {
    padding: "2rem",
  },
}));
const InclusiverseTasks = styled(Box)(({ theme }) => ({
  flex: "1 0 250px",
  backgroundColor: theme.colors.yellowLight,
  flexDirection: "row",
  ul: {
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    margin: 0,
    maxWidth: 275,
    padding: 0,
  },
  li: {
    alignItems: "center",
    display: "flex",
    gap: 10,
    lineHeight: 1.3,
  },
  svg: {
    display: "block",
    width: 45,
    flex: "0 0 45px",
    height: 45,
  },
  p: {
    margin: 0,
    maxWidth: "13em",
  },
}));
const InclusiverseAbout = styled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.pinkLight,
  flex: "1 0 250px",
  "p:last-of-type": {
    marginBottom: 0,
  },
}));
const InclusiverseCTA = styled(Box)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.colors.greenLight,
  flex: "0 0 100%",
  gap: "1rem",
  textAlign: "center",
  p: {
    flex: "0 1 auto",
    maxWidth: "20em",
    margin: 0,
  },
  a: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
  },
  [theme.breakpoints.tablet]: {
    flexDirection: "row",
    textAlign: "left",
    padding: "2rem",
    gap: "2rem",
  },
}));
const HubSection = styled.section<{ textCenter?: boolean }>(
  ({ textCenter = false, theme }) => ({
    marginBottom: "calc(3.5rem + 5vw)",
    textAlign: textCenter ? "center" : "left",
  })
);

export { HomeInclusiverse };
